import { Input, Trans } from '@/components'
import { cn } from '@/utils/style'

interface ImageVolumeQuotaSectionProps {
  imageVolumeQuota: number
}

export default function ImageVolumeQuotaSection({
  imageVolumeQuota,
}: ImageVolumeQuotaSectionProps) {
  return (
    <div className="">
      <h3 className="text-primary mb-4">
        <Trans i18nKey="space.volumeItemTitleImage">Custom Image</Trans>
      </h3>
      <div className="gap-4">
        <div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-[120px]">
                <div className="flex items-baseline t-sm text-secondary">
                  <div className={cn('w-3 h-3 mr-2 bg-active')} />
                  <Trans i18nKey="space.volumeItemSubTitleImage">Image</Trans>
                </div>
              </div>
              <div className="flex items-center justify-between gap-2">
                <Input
                  value={imageVolumeQuota}
                  className="px-4 py-2.5 w-20 rounded-lg text-center t-sb text-tertiary"
                  disabled={true}
                />
                <div className="t-sm text-secondary">GB</div>
              </div>
            </div>
          </div>
          <div className="ml-[120px] mt-2 pl-3 t-sm text-tertiary">
            <Trans i18nKey="space.imageVolumeQuotaDescription">
              Any unused quota from Snapshots and Data Drives will be counted toward the Custom
              Image quota.
            </Trans>
          </div>
        </div>
      </div>
    </div>
  )
}
